const sortByNumber = (data, isArrowToggled, address) => {
  const getNestedProperty = (data, address) => {
    return address.reduce(
      (obj, key) => (obj && obj[key] !== undefined ? obj[key] : null),
      data
    );
  };

  let sortedData = data.slice().sort((a, b) => {
    let aData = getNestedProperty(a, address);
    let bData = getNestedProperty(b, address);

    // Handle undefined or null values
    if (aData === undefined || aData === null) return 1; // Move undefined/null values to the end
    if (bData === undefined || bData === null) return -1; // Move undefined/null values to the end

    return !isArrowToggled ? aData - bData : bData - aData;
  });

  return sortedData;
};

export default sortByNumber;
